import axios from "axios";
import pageURL from "../utils/pageUrls";



const customAxios = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const requestHandler = (request) => {
  const token = (localStorage.getItem("token") ?? "").replace(/"/gi, "");
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
};

const responseHandler = (response, history) => {
  return response;
};

const errorHandler = (error) => {
  if (error?.response?.status === 401) {
    localStorage.removeItem("token");
    window.location.href = `${window.location.hostname}/${pageURL.login}?status=401`;
  }
  if (error?.response?.status === 403) {
    window.location.href = `${window.location.hostname}/?status=403`;
  }
  
  return Promise.reject(error.response.data);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  (error) => errorHandler(error)
);

export default customAxios;
